<template>
    <v-card>
        <v-card-title>
            <v-toolbar dense flat color="white">
                <v-icon class="mx-2" color="primary">far fa-calendar-alt</v-icon>
                <v-toolbar-title>Scadenziario</v-toolbar-title>
                <v-divider
                        class="mx-5"
                        inset
                        vertical
                ></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
        </v-card-title>
        <v-card-text style="min-height: 200px;">
            <fatel-tickler-component :landscape="true" :title="true"></fatel-tickler-component>
        </v-card-text>
    </v-card>
</template>

<script>

    export default {
        name: "Tickler",
        data() {
            return {
            }
        },
        mounted() {
        }
    }
</script>

<style scoped>

</style>